import { useEffect } from 'react';
import { Layout } from '../../components/Layout';
import { MessageCenterContent } from './MessageCenterContent';

export const MessageCenter = () => {
  useEffect(() => { document.title = 'Messages - SIYAK'; }, []);
  return (
    <Layout>
      <MessageCenterContent />
    </Layout>
  );
};
